<template>
  <div class="view">
    <header
      :style="{height:ratio* 66+'px'}"
      class="scrolled">
      <div
        :style="{fontSize:18*ratio+'px',marginLeft:ratio*275+'px'}"
        class="tab">
        <a
          :class="urlPath=='/'?'active':''"
          :style="{lineHeight:ratio*65+'px'}"
          :href="activityCode ? '/?activity_code=' + activityCode :'/'">首页</a>
      </div>
      <div
        :style="{fontSize:18*ratio+'px',marginLeft:ratio*70+'px'}"
        class="tab">
        <a
          :class="urlPath=='/cloudProduct'?'active':''"
          :style="{lineHeight:ratio*65+'px'}"
          :href="activityCode ? '/cloudProduct?activity_code=' + activityCode :'/cloudProduct'">产品中心</a>
      </div>
      <div
        :style="{fontSize:18*ratio+'px',marginLeft:ratio*70+'px'}"
        class="tab">
        <a
          :class="urlPath=='/cloudMessage' || urlPath=='/messageDetail'?'active':''"
          :style="{lineHeight:ratio*65+'px'}"
          :href="activityCode ? '/cloudMessage?activity_code=' + activityCode :'/cloudMessage'">餐饮资讯</a>
      </div>
      <div
        :style="{paddingLeft:57*ratio+'px',paddingRight:57*ratio+'px',height:ratio*40+'px',width:ratio*129+'px',fontSize:ratio*14+'px',lineHeight:ratio*40+'px',marginTop:ratio*13+'px',}"
        class="button-wrap">
        <div
          v-show="showDownload && !isMobile"
          :style="{borderRadius:ratio*4+'px'}"
          class="button"
          @click="download()">立即下载</div>
      </div>
    </header>
    <div :style="{height:ratio*66+'px'}"></div>

    <slot></slot>

    <template v-if="showFooter">
      <div :style="{height:ratio*214+'px'}"></div>
      <footer :style="{height:ratio*214+'px'}">
        <div
          :style="{width:770*ratio+'px', height:132*ratio+'px',}"
          class="footer-content">
          <div class="link">
            <span :style="{verticalAlign:'middle',fontSize:20*ratio+'px'}">友情链接</span>
            <ul :style="{fontSize:ratio*16+'px',marginLeft:ratio*20+'px'}">
              <li>
                <a href="http://www.meituan.com">美团</a>
              </li>
              <li :style="{paddingLeft:10*ratio+'px',paddingRight:10*ratio+'px'}">
                <a href="http://www.dianping.com">大众点评</a>
              </li>
              <li :style="{paddingLeft:10*ratio+'px',paddingRight:10*ratio+'px'}">
                <a href="http://e.meituan.com">开店宝</a>
              </li>
              <li :style="{border:'none', paddingLeft:10*ratio+'px'}">
                <a href="http://paidui.meituan.com">美团排队</a>
              </li>
            </ul>
          </div>
          <div class="contact">
            <span :style="{verticalAlign:'middle',fontSize:20*ratio+'px'}">联系我们</span>
            <ul :style="{fontSize:ratio*16+'px',width:200*ratio+'px',marginLeft:ratio*20+'px'}">
              <li :style="{border:'none',width:ratio*200+'px'}">电话&nbsp;:&nbsp;021-10105557</li>
            </ul>
          </div>
          <div
            :style="{fontSize:16*ratio+'px', marginTop:64*ratio+'px'}"
            class="copyright">@2017 meituan.com 京ICP证070791号 <a
              style="margin-left: 20px"
              target="_blank"
              href="/userProtocol">云店助手用户协议</a></div>
          <img
            :style="{height:20*ratio+'px',marginTop:28*ratio+'px'}"
            src="../../assets/img/MTDP-logo.png">
        </div>
      </footer>
    </template>
  </div>
</template>
<script>
import { Ajax, getBrowserVersion, getUrlParam } from '@/lib/utils';
import getEnv from '@/lib/env';
import config from '@/lib/config';
import { downloadClick, pageView } from './pageRecord';

export default {
  props: {
    showDownload: {
      type: Boolean,
      default: false,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      downloadUrl: '',
      urlPath: '',
      activityCode: '',
      version: '',
      isMobile: false,
      isActive: false,
      ratio: document.documentElement.clientWidth / 1280,
    };
  },
  created() {
    const env = getEnv();
    const url = `${window.location.protocol}//${config.env[env].serverDomain}/pc/ajax/getDownloadUrl`;
    Ajax.get({
      url,
      success: (res) => {
        if (res.code !== '200') return;
        this.downloadUrl = res.data.url;
        this.version = res.data.version;
      },
    });
  },
  mounted() {
    pageView();
    this.urlPath = window.location.pathname;
    this.activityCode = getUrlParam('activity_code');
    const browser = {
      versions: getBrowserVersion(),
    };
    // 移动端隐藏下载按钮
    if (browser.versions.mobile || browser.versions.ios || browser.versions.android
            || browser.versions.iPhone || browser.versions.iPad) {
      this.isMobile = true;
    }
    window.addEventListener('resize', this.ratioCalc);
    window.addEventListener('scroll', this.scrollFlag);
  },
  methods: {
    ratioCalc() {
      this.ratio = document.documentElement.clientWidth / 1280;
    },
    scrollFlag() {
      this.isActive = !!window.pageYOffset;
    },
    download() {
      downloadClick({
        clientVersion: this.version,
      });
      window.open(this.downloadUrl, '_blank');
    },
  },
};
</script>
<style lang="less">
* {
    margin: 0;
    padding: 0;
}
body {
    scroll-behavior: smooth;
    font-family: MicrosoftYaHei, "MicrosoftYaHei", "Microsoft YaHei", "微软雅黑", sans-serif;
    min-width: 300px;
}
.view {
    position: relative;
    min-height: 100vh;
}
header {
    background-image: url('../../assets/img/header.png');
    background-size: 100% 100%;
    img {
        height: 36px;
        float: left;
    }
    .tab{
        cursor:pointer;
        float:left;
        color:#fff;
        text-align:center;
        height: 100%;
        a{
            color:#fff!important;
            display:inline-block;
            height:100%;
            line-height: 100%;
            text-decoration:none;
        }
        a.active{
            border-bottom:2px solid #157EDC;
            color:#157EDC!important;
            box-sizing: border-box;
        }
    }
    .button-wrap{
        position: absolute;
        right: 0;
        min-width: 60px;
        background-color: #0A0A13;

        .button {
            height: 100%;
            width: 100%;
            color:#fff;
            border:1px solid #fff;
            text-align: center;
            cursor:pointer;
        }
    }
}
header.scrolled{
    position:fixed;
    width:100%;
    z-index:999;
}
footer {
    overflow: hidden;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #212331;
    font-family: "微软雅黑", "Microsoft YaHei", sans-serif;
    color: #fff;
    .footer-content {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        .link {
            float: left;
            width: 60%;
        }
        .contact {
            float: right;
            width: 40%;
        }
        .copyright {
            text-align: center;
            color: #5d5e66;
        }
        ul {
            width: 72.2%;
            vertical-align: middle;
            margin-left: 20px;
            display: inline-block;
            color: #5d5e66;
            li {
                width: 20%;
                float: left;
                list-style: none;
                text-align: center;
                border-right: 1px solid #5d5e66;
            }
        }
        a {
            color: #5d5e66;
            text-decoration: none;
        }
        a:hover,
        a:active {
            color: #fff;
        }
        img {
            margin-left: auto;
            margin-right: auto;
            display: block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout-common/shop-layout.vue